<template>
  <div id="LandingCheckIn">
    <Header
      @login="login"
      @openSideMenu="openSideMenu"
      @openProfile="openProfile"
      :style="
        header_border
          ? 'border-bottom: 1px solid #ddd;padding-bottom: ' +
            Config.options.padding_bottom_for_header
          : ''
      "
    />
    <SideMenu ref="SideMenu" @login="login" @openProfile="openProfile" />
    <Home
      @openMap="openMap"
      @openVendor="openVendor"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_home_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_home_section +
          ' !important;'
      "
    />

    <Footer />

    <Agencies
      v-if="!is_mobile && Config.is_organization"
      ref="Agencies"
      @openVendor="openVendor"
      @backHome="backHome"
      @removeBorder="removeBorder"
      @toggleButtonOn="toggleButtonOn"
      @toggleButtonOff="toggleButtonOff"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_agencies_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_agencies_section +
          ' !important;'
      "
      :regions="regions"
    />
    <AgenciesMobile
      v-else-if="Config.is_organization"
      ref="Agencies"
      @openVendor="openVendor"
      @removeBorder="removeBorder"
      @backHome="backHome"
      @toggleButtonOn="toggleButtonOn"
      @toggleButtonOff="toggleButtonOff"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_agencies_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_agencies_section +
          ' !important;'
      "
      :regions="regions"
    />

    <Vendor
      v-if="!is_mobile"
      ref="Agency"
      @login="login"
      @pinMapTo="pinMapTo"
      @removeBorder="removeBorder"
      @toggleButtonOff="toggleButtonOff"
      :renderButtonsOnOff="renderButtonsOnOff"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_vendor_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_vendor_section +
          ' !important;'
      "
    />
    <VendorMobile
      v-else
      ref="Agency"
      @login="login"
      @pinMapTo="pinMapTo"
      @removeBorder="removeBorder"
      @toggleButtonOff="toggleButtonOff"
      :renderButtonsOnOff="renderButtonsOnOff"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_vendor_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_vendor_section +
          ' !important;'
      "
    />

    <Login ref="LoginModal" />
    <!-- confirm account component -->
    <ConfirmAccount ref="UpdateModel" :user="user !== null ? user : {}" />
    <SurveyClient
      ref="SurveyClient"
      @checkFeedback="checkFeedback"
      :user="user !== null ? user : {}"
    />
    <Profile
      ref="Profile"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_profil_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_profil_section +
          ' !important;'
      "
    />
    <Feedback
      ref="Feedback"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_profil_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_profil_section +
          ' !important;'
      "
    />
    <FeedbackMobile
      ref="FeedbackMobile"
      :style="
        'padding-top: ' +
          Config.options.padding_top_for_profil_section +
          ' !important;padding-bottom: ' +
          Config.options.padding_bottom_for_profil_section +
          ' !important;'
      "
    />
  </div>
</template>

<script>
import $ from "jquery";

import Header from "./components/Header.vue";
import SideMenu from "./components/SideMenu.vue";
import Profile from "./Profile.vue";
import Feedback from "./components/Feedback.vue";
import FeedbackMobile from "./components/FeedbackMobile.vue";
import Home from "./Home.vue";
import Footer from "./components/Footer.vue";

import Agencies from "./Agencies.vue";
import AgenciesMobile from "./AgenciesMobile.vue";

import Vendor from "./vendor/Index.vue";
import VendorMobile from "./vendorMobile/Index.vue";
import ConfirmAccount from "./modals/ConfirmAccount.vue";
import SurveyClient from "./modals/SurveyClient.vue";

var Config = require("@config");

import { queueService, investigationsService, userService } from "../_services";

import Login from "./auth/Login.vue";

export default {
  data: () => ({
    // make the ticket & appointment div disappear/appear
    user: {},
    organizationId: "",
    renderButtonsOnOff: true,
    toggleIndex: 1,
    query_vendor_hid: null,
    screen_width: null,
    is_mobile: false,
    header_border: false,
    regions: []
  }),
  components: {
    Header,
    Home,
    Footer,
    Agencies,
    AgenciesMobile,
    Vendor,
    VendorMobile,
    ConfirmAccount,
    SurveyClient,
    Login,
    SideMenu,
    Profile,
    Feedback,
    FeedbackMobile,
  },
  mounted() {
    this.organizationId = Config.organization_id;
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.$route.query.hid || this.$route.params.short_code) {
      $("#PreLoader").show();
      setTimeout(
        function() {
          this.openVendorFromUrl();
        }.bind(this),
        300
      );
    }
    this.pageResized();
    if (this.user !== null) {
      if (this.user.fullname && this.user.fullname.length <= 1) {
        this.openConfirmAccount();
      }
    }

    // try {
    //   if (this.user !== null) {
    //   // get surveys
    //   investigationsService
    //     .getAll(this.organizationId)
    //     .then(
    //       function(res) {
    //         if (res.investigations.length === 0) {
    //           // this.openFeedback();
    //           if (this.user) {
    //             let payload = null;
    //             if (this.Config.is_organization) {
    //               payload = {
    //                 organization_id: this.Config.organization_id,
    //               };
    //             } else {
    //               payload = {
    //                 business_id: this.Config.default_business_id,
    //               };
    //             }
    //             queueService.getNoFeedbackArchive(payload).then(
    //               function(res) {
    //                   this.openFeedback(res.ticket.unique_id);
    //               }.bind(this)
    //             );
    //           }
    //         } else {
    //           this.openSurveyClient(res.investigations);
    //         }
    //       }.bind(this)
    //     )
    //     .catch(
    //       function(err) {
    //         console.log(err);
    //       }.bind(this)
    //     );
    //   }
    // } catch (err) {
    //   console.log(err);
    // }

    // userService.getAllZones().then(function (res) {
    //   this.regions = res.data.filter(el => el.states.length > 0);
    // }.bind(this))
  },
  created() {
    window.addEventListener("resize", this.pageResized);
  },
  methods: {
    openProfile() {
      this.$refs.Profile.show();
    },
    openFeedback(uid) {
      if (!this.is_mobile) {
        this.$refs.Feedback.show(uid);
      } else {
        this.$refs.FeedbackMobile.show(uid);
      }
    },
    checkFeedback() {
      if (this.user) {
        queueService.getTicketsArchived().then(
          function(res) {
            if (
              res.tickets.data[0]["rated"] == 0 &&
              res.tickets.data[0]["feedback_ignored"] == 0
            ) {
              this.openFeedback(res.tickets.data[0]["unique_id"]);
            }
          }.bind(this)
        );
      }
    },
    openSideMenu() {
      this.$refs.SideMenu.show();
    },
    removeBorder() {
      this.header_border = false;
    },
    pinMapTo(id, position) {
      if (!this.is_mobile) {
        this.$refs.Agencies.pinMapTo(id, position);
      }
    },
    openVendorFromUrl() {
      if (this.$route.query.hid) {
        this.query_vendor_hid = this.$route.query.hid;
        if (this.$refs.Agencies) {
          this.$refs.Agencies.show();
        }
        this.$refs.Agency.show(this.query_vendor_hid, true);
        this.header_border = true;
      } else if (this.$route.params.short_code) {
        this.query_vendor_hid = this.$route.params.short_code;
        if (this.$refs.Agencies) {
          this.$refs.Agencies.show();
        }
        this.$refs.Agency.showByShortCode(this.query_vendor_hid, true);
        this.header_border = true;
      }
      $("#PreLoader").hide();
    },
    pageResized() {
      this.screen_width = $(window).width();
      if (this.screen_width > this.Config.home.mobile_max_width) {
        this.is_mobile = false;
      } else {
        this.is_mobile = true;
      }
    },
    login() {
      this.$refs.LoginModal.show();
    },
    openConfirmAccount() {
      this.$refs.UpdateModel.show();
    },
    openSurveyClient(surveys) {
      this.$refs.SurveyClient.show(surveys);
    },
    backHome() {
      this.$refs.Agency.hide();
      this.header_border = false;
    },
    openVendor(short_code) {
      this.$refs.Agency.showByShortCode(short_code);
      this.header_border = true;
      this.renderButtonsOnOff = true;
    },
    // make the ticket & appointment div disappear/appear
    toggleButtonOn() {
      this.renderButtonsOnOff = true;
    },
    toggleButtonOff() {
      this.renderButtonsOnOff = false;
    },
    openMap() {
      this.$refs.Agencies.show();
      this.header_border = true;
    },
    showLoading() {
      this.$vs.loading({
        container: "#checkin-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#checkin-box > .con-vs-loading");
    },
  },
};
</script>

<style lang="scss" scoped>
#LandingCheckIn {
  overflow: hidden !important;
  height: 100vh !important;
  position: relative !important;
}
</style>
